import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { FloatActionBar } from "@eudonet/opal";
import { useI18n } from "vue-i18n";
/**
 * OPAL FloatActionBar pre-wired with the shared `table.bulk.*` labels, so every list
 * surfaces the same localized bar (R29 — OPAL never translates; a hand-copied partial
 * label set is a compile error on the required props, hence this single wiring point).
 *
 * Render it unconditionally next to the list's DataTable: the bar's own
 * `selectionCount > 0` gate hides it until a row is checked. Pair with
 * `useListRowSelection` for the checkbox column + selection state.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'ListFloatActionBar',
    props: {
        selectionCount: {},
        allPagesSelected: { type: Boolean, default: false },
        totalAcrossAllPages: { default: undefined },
        actions: { default: () => [] },
        isLoading: { type: Boolean, default: false }
    },
    emits: ["dismiss", "action-click", "select-all-pages"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(FloatActionBar), {
                "selection-count": __props.selectionCount,
                "all-pages-selected": __props.allPagesSelected,
                "total-across-all-pages": __props.totalAcrossAllPages,
                actions: __props.actions,
                "is-loading": __props.isLoading,
                ariaLabel: _unref(t)('table.bulk.ariaLabel'),
                "selected-item-label": _unref(t)('table.bulk.selectedItem'),
                "selected-items-label": _unref(t)('table.bulk.selectedItems'),
                "select-all-pages-label": _unref(t)('table.bulk.selectAllPages'),
                "more-label": _unref(t)('table.bulk.more'),
                "more-actions-title": _unref(t)('table.bulk.moreActions'),
                "total-unavailable-label": _unref(t)('table.bulk.totalUnavailable'),
                "selection-cleared-label": _unref(t)('table.bulk.selectionCleared'),
                onDismiss: _cache[0] || (_cache[0] = ($event) => (emit('dismiss'))),
                onActionClick: _cache[1] || (_cache[1] = (actionId, selectionContext) => emit('action-click', actionId, selectionContext)),
                onSelectAllPages: _cache[2] || (_cache[2] = (checked) => emit('select-all-pages', checked))
            }, null, 8 /* PROPS */, ["selection-count", "all-pages-selected", "total-across-all-pages", "actions", "is-loading", "ariaLabel", "selected-item-label", "selected-items-label", "select-all-pages-label", "more-label", "more-actions-title", "total-unavailable-label", "selection-cleared-label"]));
        };
    }
});
